// eslint-disable-next-line no-restricted-imports
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

export type { ToasterProps };

export const Toaster = (props: ToasterProps) => (
  <SonnerToaster position="bottom-right" gap={8} {...props} />
);
